import { Component,  Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ShiftRecord } from 'src/shared/models/shift-record.model';
import { isNumber } from 'util';
import { NgForm } from '@angular/forms';
import { HoursCalculator } from 'src/shared/models/Hours-calculator.model';
import { StaffRatioValue } from 'src/shared/models/staff-ratio-value.model';


@Component({
    selector: 'smt-hours-calculator',
    templateUrl: './hours-calculator.component.html',
    styleUrls: ['./hours-calculator.component.scss']
})
export class HoursCalculatorComponent {

    public hoursCalculatorForm: NgForm;
    @Input() shiftRecord: ShiftRecord;
    @Input() targetStaffs: StaffRatioValue[];
    @Input() completedRows: HoursCalculator[];
    @Output() acceptEvent: EventEmitter < any > = new EventEmitter < any > ();
    @Output() rejectEvent: EventEmitter < any > = new EventEmitter < any > ();

    IsShowCalculatorModal = true;
    rows: HoursCalculator[];

    ngOnInit() {
        this.rows = [];
       this.completedRows.length > 0 ? this.LoadPreviousData(): this.initalizeFormData()

    }
    constructor(private changeDetector: ChangeDetectorRef) {}
    ngAfterViewChecked() {
        this.changeDetector.detectChanges();
    }

    LoadPreviousData() {
        this.completedRows.forEach((JobTitle) => {
            let row: HoursCalculator = new HoursCalculator();
            row.JobTitle = JobTitle.JobTitle,
            row.TotalHours = JobTitle.TotalHours,
            row.TargetHours = this.targetStaffs.find(r => r.jobTitleId === JobTitle.JobTitle.id).staffValue,
            row.FourHoursStaff = JobTitle.FourHoursStaff
            row.EightHoursStaff = JobTitle.EightHoursStaff
            row.TenHoursStaff =JobTitle.TenHoursStaff
            row.TwelveHoursStaff = JobTitle.TwelveHoursStaff;
            this.rows.push(row);
        })
    }

    initalizeFormData() {
        this.shiftRecord.costCenter.variableJobTitles.forEach((JobTitle) => {
            let row: HoursCalculator = new HoursCalculator();
            row.JobTitle = JobTitle,
            row.TargetHours = this.targetStaffs.find(r => r.jobTitleId === JobTitle.id).staffValue
            row.FourHoursStaff = row.EightHoursStaff = row.TenHoursStaff = row.TwelveHoursStaff = null;
            this.rows.push(row);
        })
    }

    DoneCalculations() {
        this.acceptEvent.emit(this.rows);
    }

    closeModal() {
        this.rejectEvent.emit("reject");
    }

    onCellKeyDown(e: any) {

        if (!((e.keyCode > 95 && e.keyCode < 106) ||
                (e.keyCode > 47 && e.keyCode < 58) ||
                (e.keyCode > 36 && e.keyCode < 41) ||
                e.keyCode == 8 || e.keyCode == 9)) {
            return false;
        }
    }



    getTotalStaff(JobTitle: any) {

        let Total = null;

        if (isNumber(JobTitle.FourHoursStaff)) {
            Total += JobTitle.FourHoursStaff * 4;
        }

        if (isNumber(JobTitle.EightHoursStaff)) {
            Total += JobTitle.EightHoursStaff * 8;
        }
        if (isNumber(JobTitle.TenHoursStaff)) {
            Total += JobTitle.TenHoursStaff * 10;
        }
        if (isNumber(JobTitle.TwelveHoursStaff)) {
            Total += JobTitle.TwelveHoursStaff * 12;
        }
        JobTitle.TotalHours = Total;       

        return Total;
    }

    getTargetWarning(JobTitle: any) {

        let TargetDifference =  JobTitle.TotalHours -JobTitle.TargetHours
        let warning = Math.sign(TargetDifference) === 1 ?
            `${JobTitle.JobTitle.abbreviation} Over Target Hours by ${TargetDifference.toFixed(2)}` :
            `${JobTitle.JobTitle.abbreviation} Under Target Hours by ${Math.abs(TargetDifference).toFixed(2)}`;
        return warning;
    }

    ShowVarianceWarningSection(JobTitle: any) {
        if (isNumber(JobTitle.TotalHours)) {
            return JobTitle.TargetHours - JobTitle.TotalHours == 0 ? false : true;
        }
        return false
    }
}
